define('viewModels/privileged/composer/forms/formEditor/FormErrorDialogView',[
    'lib/knockout',
    'lib/lodash4',
    'viewModels/ViewModel'
], function (
    ko,
    _,
    ViewModel
) {
    "use strict";

    return ViewModel.extend(function(validationErrors, options) {
        var self = this;

        var config = _.assign({
            cancellable: false,
            title: 'composer.evaluations.editor.moveValidations.dialog.title'
        }, options);

        var cancel = function () {
            if (self.showInlineDialog()) {
                if(config.onCancel){
                    config.onCancel();
                }
            }
        };

        // For the cancellable (x) button on the Dialog
        self.cancel = ko.observable(cancel);

        self.showInlineDialog = ko.observable(false);
        self.cancellable = ko.observable(config.cancellable);
        self.title = config.title;
        self.viewModel = {
            validationErrors: validationErrors,
            cancel: cancel // For the Cancel button in the form
        };
        self.template = 'templates/appMain/privilegedMain/composer/forms/formEditor/formErrorDialog';
    });
});
